import script from "./PonWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./PonWidget.vue?vue&type=script&setup=true&lang=js"

import "./PonWidget.vue?vue&type=style&index=0&id=72b2005a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72b2005a"]])

export default __exports__